export const spanish = {
  test: 'TestSpanish',
};
